import Vue from 'vue'
import config from "@/configuration/config-provider";

let confPlugin = {
    install(Vue, options) {
        Vue.prototype.$conf = config;
    }
}
Vue.use(confPlugin)